import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { captureAsyncThunkError } from '@chronos/utils';
import eventEmitter from '@chronos/utils/eventEmitter';
import chronosApi from '@chronos/api-client/chronosApi';
import trelloApi from '@chronos/api-client/trelloApi';

const REDUCER_NAME = 'card';

const initialState = {
  card: {},
  estimates: [],
  progressStats: {
    leftPercentage: 100,
    rightPercentage: 0,
    isOverEstimate: false,
    leftMark: '',
    rightMark: '',
  },
};

export const fetchCard = createAsyncThunk(
  `${REDUCER_NAME}/fetchCard`,
  (cardId) => trelloApi.getCard({ params: { cardId } })
);

export const createWorklog = createAsyncThunk(
  `${REDUCER_NAME}/createWorklog`,
  async (data) => {
    const body = {
      ...data,
      screenshotsPeriod: 600,
      activity: [],
      type: data.type || 'manual',
    };
    eventEmitter.emit('saveWorklog', { body });
    const response = await chronosApi.saveWorklog({ body });
    eventEmitter.emit('saveWorklogFinish', { body });
    return response;
  }
);

export const updateWorklog = createAsyncThunk(
  `${REDUCER_NAME}/updateWorklog`,
  async (values) => {
    const body = { worklogId: values.id, ...values };
    const response = await chronosApi.updateWorklog({ body });
    eventEmitter.emit('updateWorklog', { body });
    return response;
  }
);

export const cardSlice = createSlice({
  name: REDUCER_NAME,
  initialState: {
    ...initialState,
  },
  reducers: {
    setProgressStats: (state, action) => {
      state.progressStats = action.payload;
    },
    resetState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCard.fulfilled, (state, action) => {
      state.card = action.payload;
    });
    builder.addCase(fetchCard.rejected, captureAsyncThunkError);
    builder.addCase(createWorklog.rejected, captureAsyncThunkError);
    builder.addCase(updateWorklog.rejected, captureAsyncThunkError);
  },
});

const selectSelf = (state) => state.shared[REDUCER_NAME];
export const selectCard = (state) => selectSelf(state).card;
export const selectProgressStats = (state) => selectSelf(state).progressStats;

export const { actions, reducer } = cardSlice;

export const { setProgressStats, resetState } = actions;

export default reducer;
